import React, { useEffect, useState } from 'react';
import './RezRateSideDrawer.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

const RezRateSideDrawer = ({ children, isOpen, setIsOpen, options }) => {
  const {
    width = '250px',
    title = 'Side Drawer',
    backgroundColor,
    position = 'left',
    renderPreview,
    arrowOffset,
    contentStyle,
  } = options || {};
  const [isDrawing, setIsDrawing] = useState(false);

  const [myRenderPreview, setMyRenderPreview] = useState(renderPreview);

  const toggleDrawer = () => {
    if (isDrawing || !setIsOpen) return; // Prevent toggling while drawing
    setIsDrawing(true);
    setTimeout(() => {
      setIsDrawing(false);
    }, 1000);
    setIsOpen(!isOpen);
  };

  const isLeft = position === 'left';

  const drawerStyle = {
    zIndex: 900,
    width,
    backgroundColor,
    left: isLeft ? 0 : 'auto',
    right: isLeft ? 'auto' : 0,
    transform: isOpen ? 'translateX(0)' : isLeft ? 'translateX(-100%)' : 'translateX(100%)',
  };

  const handleStyle = {
    [isLeft ? 'right' : 'left']: arrowOffset ? `calc(-${arrowOffset}px - 30px)` : '-30px',
    borderRadius: isLeft ? '0 5px 5px 0' : '5px 0 0 5px',
  };

  useEffect(() => {
    setMyRenderPreview(renderPreview);
  }, [renderPreview]);

  return (
    <div className={`side-drawer ${isOpen ? 'open' : ''}`} style={drawerStyle}>
      <div className="drawer-handle" onClick={toggleDrawer} style={handleStyle}>
        <FontAwesomeIcon
          icon={isLeft ? (isOpen ? faChevronLeft : faChevronRight) : isOpen ? faChevronRight : faChevronLeft}
          style={{ width: 30 }}
        />

        {myRenderPreview}
      </div>

      <div className="drawer-content" style={contentStyle}>
        {children}
      </div>
    </div>
  );
};

export default RezRateSideDrawer;
